import { useSetRecoilState } from "recoil";
import { companyManagementSearchAtom } from "../miscellaneous/companyManagementSearchAtom";

export const useSetCompanyManagementSearch = () => {
  return useSetRecoilState(companyManagementSearchAtom);
};
